import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AUDIT_SOURCE } from '../models/audit-source.model';

/**
 * Interceptor that adds the X-Audit-Source header to all outgoing HTTP requests.
 * The header value is provided per application via the AUDIT_SOURCE injection token.
 */
export const auditSourceInterceptor: HttpInterceptorFn = (req, next) => {
  const auditSource = inject(AUDIT_SOURCE);
  const clonedRequest = req.clone({
    setHeaders: { 'X-Audit-Source': auditSource }
  });
  return next(clonedRequest);
};
